module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "m-l-50 m-t-30"
  }, [_c('common-config', {
    attrs: {
      "id": _vm.id,
      "form": _vm.form,
      "isLimit": false
    }
  }, [_c('template', {
    slot: "self-config"
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "110px",
      "label": "定制组件唯一标识"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.iden),
      expression: "form.iden"
    }],
    staticClass: "w-200",
    domProps: {
      "value": (_vm.form.iden)
    },
    on: {
      "input": function($event) {
        _vm.form.iden = $event
      }
    }
  })]), _vm._v(" ")])], true)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a87e900a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/abstract/dealConfig/selfConfig.vue
// module id = 1971
// module chunks = 2